module.exports = __webpack_public_path__ + "img/fridge-active-icon.e3e125ed.svg";